// habitNotes.js — the optional note on a habit's logged day (2026-10-22).
// habits.notes is { 'YYYY-MM-DD': text }. Never prompted: "+ note" or a
// long-press after a tick. Free text the user typed, so it is handled like
// journal text: into Kai's context only with journal consent, never on the
// lock screen (push-guard journal-quote check), scrubbed from crash reports.
export const HABIT_NOTE_MAX = 140;

export const habitNoteFor = (notes, date) => (notes && typeof notes === 'object' && typeof notes[date] === 'string' && notes[date].trim()) ? notes[date].trim() : null;

/**
 * notes with `date` set to `text` (blank = removed), trimmed to dates on or
 * after `keepSince` (the 90-day history cutoff). Returns a new object.
 */
export function setHabitNote(notes, date, text, { keepSince = '0000-00-00' } = {}) {
  const out = {};
  for (const [d, v] of Object.entries(notes && typeof notes === 'object' ? notes : {})) {
    if (d >= keepSince && typeof v === 'string' && v.trim()) out[d] = v.trim().slice(0, HABIT_NOTE_MAX);
  }
  const t = String(text || '').trim().slice(0, HABIT_NOTE_MAX);
  if (t && date >= keepSince) out[date] = t; else delete out[date];
  return out;
}
